import { useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {Button, Col, Input, Row, Space, Spin, Typography} from "antd";
import {useEffect, useState} from "react";
import {PlusOutlined} from "@ant-design/icons";
import WorkTimeTable from "./WorkTimeTable";
import {  useDeleteQuery, useGetQuery} from "../../service/query/Queries";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
const {Title}=Typography

const WorkTime = () => {

    const navigate = useNavigate()


    const {data,isLoading:getLoading,refetch}=useGetQuery(false,'work-time-get',`/work-time` , false)

    const ScreenMD = useBreakpoint().md;

    // delete

    useEffect(() => {
        refetch()
    }, []);

    // add
    const addArticle = () => {
        navigate('/work-time/add');
    };


    return (
        <div className={'site-space-compact-wrapper'}>
            <Space direction={'vertical'} size={"large"} style={{width: '100%'}}>
                <Row gutter={[10 , 20]}>
                    <Col span={18}>
                        <Title className={'page--title'} level={2}>
                            Рабочее время
                        </Title>
                    </Col>
                    {/*<FilterCompanyForAdmin/>*/}

                    <Col span={8} offset={16}>
                        <Button
                            disabled={data && data[0]?.startTime}
                            type='primary'
                            icon={<PlusOutlined/>}
                            style={{width: '100%'}}
                            onClick={addArticle}>
                            {
                                ScreenMD && 'Добавить'
                            }
                        </Button>
                    </Col>

                </Row>
                <Spin
                    size='medium'
                    spinning={getLoading }>
                    <WorkTimeTable
                        data={ data}

                    />
                </Spin>
            </Space>
        </div>
    );
};

export default WorkTime;